/*
  Desert Supply Club — Product Page JavaScript
  File: assets/dsc-product.js

  SETUP: Upload this file to your Shopify theme under Assets.
  It is loaded automatically by dsc-product-page.liquid
*/

(function () {
  'use strict';

  /* ══════════════════════════════════════════
     IMAGE GALLERY
  ══════════════════════════════════════════ */

  window.dscSwitchImage = function (index) {
    // Update thumbnails
    document.querySelectorAll('.dsc-thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    var activeThumb = document.querySelector('.dsc-thumb[data-index="' + index + '"]');
    if (activeThumb) activeThumb.classList.add('active');

    // Update main image
    document.querySelectorAll('.dsc-main-image').forEach(function (img) {
      img.classList.remove('active');
    });
    var activeImg = document.querySelector('.dsc-main-image[data-index="' + index + '"]');
    if (activeImg) activeImg.classList.add('active');
  };

  /* ══════════════════════════════════════════
     PLAN SELECTOR
  ══════════════════════════════════════════ */

  window.dscSelectPlan = function (el, planId) {
    // Update UI
    document.querySelectorAll('.dsc-plan-option').forEach(function (opt) {
      opt.classList.remove('selected');
    });
    el.classList.add('selected');

    // Update hidden input for cart
    var planInput = document.getElementById('dscSellingPlanId');
    if (planInput) planInput.value = planId;
  };

  /* ══════════════════════════════════════════
     ADD TO CART
  ══════════════════════════════════════════ */

  window.dscAddToCart = function () {
    var btn = document.getElementById('dscAtcBtn');
    var variantId = document.getElementById('dscVariantId');
    var sellingPlanId = document.getElementById('dscSellingPlanId');

    if (!variantId) {
      console.warn('DSC: No variant ID found');
      return;
    }

    var payload = {
      items: [{
        id: parseInt(variantId.value),
        quantity: 1
      }]
    };

    // Include selling plan if present
    if (sellingPlanId && sellingPlanId.value) {
      payload.items[0].selling_plan = parseInt(sellingPlanId.value);
    }

    // Loading state
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);
      return res.json();
    })
    .then(function () {
      // Success state
      if (btn) {
        btn.textContent = 'Added to Cart ✓';
        btn.style.background = 'var(--dsc-sage)';
      }

      // Update cart count + open slide-out cart drawer
      dscOpenCartDrawer();

      // Reset button after 2.5s
      setTimeout(function () {
        if (btn) {
          btn.textContent = 'Subscribe Now — Join the Club';
          btn.style.background = '';
          btn.disabled = false;
        }
      }, 2500);
    })
    .catch(function (err) {
      console.error('DSC Add to Cart error:', err);
      if (btn) {
        btn.textContent = 'Something went wrong — try again';
        btn.style.background = 'var(--dsc-rust)';
        btn.disabled = false;
        setTimeout(function () {
          btn.textContent = 'Subscribe Now — Join the Club';
          btn.style.background = '';
        }, 3000);
      }
    });
  };

  /* Open the Dawn cart drawer with fresh contents after add-to-cart */
  function dscOpenCartDrawer() {
    // Fetch fresh cart drawer + icon bubble sections from Shopify
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var drawerEl = document.querySelector('cart-drawer');

        if (drawerEl && sections['cart-drawer']) {
          // Update drawer HTML
          var parser = new DOMParser();
          var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawerInner = drawerDoc.querySelector('#CartDrawer');
          var currentDrawerInner = document.getElementById('CartDrawer');
          if (newDrawerInner && currentDrawerInner) {
            currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
          }

          // Re-bind overlay close handler
          var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', function () { drawerEl.close(); });
          }

          // Remove empty state
          drawerEl.classList.remove('is-empty');

          // Open the drawer
          setTimeout(function () {
            drawerEl.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }, 50);
        }

        // Update cart icon bubble count
        if (sections['cart-icon-bubble']) {
          var bubbleParser = new DOMParser();
          var bubbleDoc = bubbleParser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
          var currentBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        }

        // Fallback: also update common cart count selectors
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var selectors = ['[data-cart-count]', '.cart-count', '#cart-count', '.cart__count', '.header__cart-count'];
            selectors.forEach(function (sel) {
              document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; });
            });
          }).catch(function () {});
      })
      .catch(function (err) {
        console.warn('DSC: Could not open cart drawer, falling back', err);
        // Fallback: redirect to cart page
        window.location.href = '/cart';
      });
  }

  /* ══════════════════════════════════════════
     FAQ ACCORDION
  ══════════════════════════════════════════ */

  window.dscToggleFaq = function (btn) {
    var item = btn.closest('.dsc-faq-item');
    var wasOpen = item.classList.contains('open');

    // Close all
    document.querySelectorAll('.dsc-faq-item').forEach(function (i) {
      i.classList.remove('open');
    });

    // Open clicked if it was closed
    if (!wasOpen) {
      item.classList.add('open');
    }
  };

  /* ══════════════════════════════════════════
     VARIANT CHANGE LISTENER
     (handles Shopify's default variant selector if present)
  ══════════════════════════════════════════ */

  document.addEventListener('DOMContentLoaded', function () {

    // Listen for Shopify variant changes (from Liquid variant selects)
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        var variantInput = document.getElementById('dscVariantId');
        if (variantInput) variantInput.value = e.target.value;
      }
    });

    // Keyboard support for FAQ
    document.querySelectorAll('.dsc-faq-question').forEach(function (btn) {
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          dscToggleFaq(btn);
        }
      });
    });

    // Smooth scroll to reviews when rating clicked
    var ratingLink = document.querySelector('.dsc-rating-count');
    if (ratingLink) {
      ratingLink.addEventListener('click', function (e) {
        e.preventDefault();
        var reviews = document.getElementById('dsc-reviews');
        if (reviews) {
          reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Thumb rail keyboard nav
    document.querySelectorAll('.dsc-thumb').forEach(function (thumb) {
      thumb.setAttribute('tabindex', '0');
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var idx = parseInt(thumb.dataset.index);
          dscSwitchImage(idx);
        }
      });
    });

    // Inline ATC buttons (gallery wall section)
    document.querySelectorAll('.dsc-atc-btn.dsc-atc-inline').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dscAddToCart();
      });
    });

  });

})();
